import { gql } from "@apollo/client";

export const QUERY_MY_REPORTS = gql`
  query Report(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $orderBy: [String]
    $sortBy: [String]
  ) {
    myReports(
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      sortBy: $sortBy
    ) {
      totalCount
      data {
        id
        name
        reportType
        details
        created
        modified
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const QUERY_MY_REPORT_DETAILS = gql`
  query Report($id: ID!) {
    report(id: $id) {
      created
      modified
      id
      name
      reportType
      details
      s3Path
      downloadUrl
    }
  }
`;
